export function useObjectKey<T>(key: keyof T) {
    return key;
}
